import { Button } from '@savvy-kit/components/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@savvy-kit/components/dropdown-menu';
import { ChevronDownIcon } from 'lucide-react';

import type { DropdownCellContentProps } from '../../types/cell-types';

export function DropdownCellContent<TData>({
  label,
  items,
  row,
  variant = 'secondary',
  size = 'sm',
  className,
}: DropdownCellContentProps<TData>) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger render={<Button variant={variant} size={size} className={className} />}>
        {label}
        <ChevronDownIcon className="size-4" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start">
        {items.map((item) => (
          <DropdownMenuItem
            key={item.value}
            onClick={() => item.onClick?.(row)}
            variant={item.variant}
            disabled={item.disabled}
          >
            {item.icon}
            {item.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
